import React, { useState, Fragment } from "react";
import { CANCELLATION_FEEDBACKS } from "../../graphql/queries";
import CancellationFeedbacks from ".";
//import { Grid, Form } from "tabler-react";
import { useQuery } from "@apollo/react-hooks";

const CancellationFeedbacksQueries = () => {
  const [searchText, setSearchText] = useState("");
  const [pageNumberState, setPageNumberState] = useState(1);
  const [productName, setProductName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterHexUsers, setFilterHexUsers] = useState(true);
  const [orderBy, setOrderBy] = useState("");
  const [orderByASC, setOrderByASC] = useState(false);

  const { data, loading } = useQuery(CANCELLATION_FEEDBACKS, {
    fetchPolicy: "no-cache",
    variables: {
      settings: {
        filter: {
          fromDate: fromDate,
          toDate: toDate,
          product: productName,
          searchValue: searchText,
          page: pageNumberState,
          limit: 100,
        },
      },
    },
    notifyOnNetworkStatusChange: true,
  });

  const handleSearchText = (searchText: string) => setSearchText(searchText);
  const handlePageNumberChange = (pageNumber: number) =>
    setPageNumberState(pageNumber);
  const handleProductSelect = (product: string) => setProductName(product);
  const handleFromDate = (date: string) => setFromDate(date);
  const handleToDate = (date: string) => setToDate(date);

  return (
    <Fragment>
      {/* <Grid.Row>
        <Grid.Col md={2}>
          <Form.Checkbox
            label="Filter Hexact Scans"
            checked={filterHexUsers}
            onChange={() => setFilterHexUsers(!filterHexUsers)}
          />
        </Grid.Col>
     </Grid.Row>*/}
      <CancellationFeedbacks
        data={data}
        loading={loading}
        onSearchText={handleSearchText}
        onPageNumberChange={handlePageNumberChange}
        onProductSelect={handleProductSelect}
        onFromDate={handleFromDate}
        onToDate={handleToDate}
        filterHexScans={filterHexUsers}
        setOrderBy={setOrderBy}
        setOrderByASC={setOrderByASC}
        orderByASC={orderByASC}
        variables={{
          filter: {
            fromDate: fromDate,
            toDate: toDate,
            product: productName,
            searchValue: searchText,
            // page: pageNumberState,
            // limit: 100,
          },
        }}
      />
    </Fragment>
  );
};

export default CancellationFeedbacksQueries;
